import * as actionType from "../types/ActionTypes";

const initialState = {
  payuPayment: [],
  postPayuPayment: [],
  error: false,
  isLoading: false,
  isPostLoading: false,
  isUpdateLoading: false,
};

export const PayuPayment = (state = initialState, action) => {
  switch (action.type) {
    case actionType.PAYU_PAYMENT_SET_DATA:
      return {
        ...state,
        payuPayment: action.payuPayment,
        error: false,
        isLoading: false,
        isPostLoading: false,
        isUpdateLoading: false,
      };

    case actionType.PAYU_PAYMENT_FAIL_DATA:
      return {
        ...state,
        error: action.error,
        isLoading: false,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.PAYU_PAYMENT_LOADING:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case actionType.PAYU_PAYMENT_POST_LOADING:
      return {
        ...state,
        isPostLoading: true,
        error: false,
      };
    case actionType.PAYU_PAYMENT_UPDATE_LOADING:
      return {
        ...state,
        isUpdateLoading: true,
        error: false,
      };
    case actionType.POST_PAYU_PAYMENT_DATA_FAIL:
      return {
        ...state,
        error: action.error,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.POST_PAYU_PAYMENT_DATA_SUCCESS:
      return {
        ...state,
        isPostLoading: false,
        error: false,
        postPayuPayment: action.postPayuPayment,
      };
    case actionType.UPDATE_PAYU_PAYMENT_DATA_FAIL:
      return {
        ...state,
        error: action.error,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.UPDATE_PAYU_PAYMENT_DATA_SUCCESS:
      return {
        ...state,
        isPostLoading: false,
        error: false,
        isUpdateLoading: false,
      };
    case actionType.UPDATE_PAYU_PAYMENT_DATA_START:
      return {
        ...state,
      };

    default:
      return state;
  }
};
